import { createSlice } from "@reduxjs/toolkit";
import {
  createNylas,
  deleteNylas
} from './actions';

export const initialState = { loading: false };

const  slice = createSlice({
  name: 'nylas',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(createNylas.pending, (state) => { state.loading = true; })
      .addCase(createNylas.fulfilled, (state) => { state.loading = false; })
      .addCase(createNylas.rejected, (state) => { state.loading = false; })
      .addCase(deleteNylas.pending, (state) => { state.loading = true; })
      .addCase(deleteNylas.fulfilled, (state) => { state.loading = false; })
      .addCase(deleteNylas.rejected, (state) => { state.loading = false; })
  }
})

export default slice.reducer;